import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from "@angular/material/icon";

import {
    AddRemovePdfButtonComponent
} from "@app/presentation/components/add-remove-pdf-button/add-remove-pdf-button.component";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    AddRemovePdfButtonComponent
  ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
    ],
  exports: [
    AddRemovePdfButtonComponent
  ]
})
export class AddRemovePdfButtonModule { }
